import React, { forwardRef } from 'react';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as ST from './styled';

export type TLabelType = Extract<
    keyof typeof COLORS,
    | 'LabelsText_1'
    | 'LabelsText_2'
    | 'LabelsText_3'
    | 'LabelsText_4'
    | 'LabelsText_5'
    | 'LabelsText_6'
>;

const colorScheme: {
    [key in TLabelType]: Extract<
        keyof typeof COLORS,
        | 'LabelsBg_1'
        | 'LabelsBg_2'
        | 'LabelsBg_3'
        | 'LabelsBg_4'
        | 'LabelsBg_5'
        | 'LabelsBg_6'
    >;
} = {
    LabelsText_1: 'LabelsBg_1',
    LabelsText_2: 'LabelsBg_2',
    LabelsText_3: 'LabelsBg_3',
    LabelsText_4: 'LabelsBg_4',
    LabelsText_5: 'LabelsBg_5',
    LabelsText_6: 'LabelsBg_6',
};

export interface ILabelProps {
    /**
     * @deprecated use `type` property
     */
    textColor?: string,

    /**
     * @deprecated use `type` property
     */
    bgColor?: string,
    className?: string,
    children: React.ReactNode,
    outlined?: boolean,
    type?: TLabelType,
    onClick?: React.MouseEventHandler<HTMLDivElement>,
}

const Label = forwardRef<HTMLDivElement, ILabelProps>(({
    textColor,
    bgColor,
    className,
    outlined,
    children,
    type,
    onClick,
}, ref): JSX.Element => {
    return (
        <ST.Label
            ref={ref}
            data-test={'label'}
            className={className}
            textColor={type ? COLORS[type] : textColor}
            bgColor={type ? COLORS[colorScheme[type]] : bgColor}
            type={type}
            outlined={outlined}
            onClick={onClick}
        >
            <ST.LabelContent type={type} data-test={'label-content'}>
                {children}
            </ST.LabelContent>
        </ST.Label>
    );
});

Label.displayName = 'Label';

export { Label };
